import { render, staticRenderFns } from "./JourneyPage.vue?vue&type=template&id=4bc16c1d&scoped=true&"
import script from "./JourneyPage.vue?vue&type=script&lang=js&"
export * from "./JourneyPage.vue?vue&type=script&lang=js&"
import style0 from "./JourneyPage.vue?vue&type=style&index=0&id=4bc16c1d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc16c1d",
  null
  
)

export default component.exports